/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiV0UserActivateUserUsernamePut } from '../fn/user/api-v-0-user-activate-user-username-put';
import { ApiV0UserActivateUserUsernamePut$Params } from '../fn/user/api-v-0-user-activate-user-username-put';
import { apiV0UserDeactivateUserUsernamePut } from '../fn/user/api-v-0-user-deactivate-user-username-put';
import { ApiV0UserDeactivateUserUsernamePut$Params } from '../fn/user/api-v-0-user-deactivate-user-username-put';
import { apiV0UserDeleteUserUsernameDelete } from '../fn/user/api-v-0-user-delete-user-username-delete';
import { ApiV0UserDeleteUserUsernameDelete$Params } from '../fn/user/api-v-0-user-delete-user-username-delete';
import { apiV0UserGetUsersByCompanyGet$Json } from '../fn/user/api-v-0-user-get-users-by-company-get-json';
import { ApiV0UserGetUsersByCompanyGet$Json$Params } from '../fn/user/api-v-0-user-get-users-by-company-get-json';
import { apiV0UserGetUsersByCompanyGet$Plain } from '../fn/user/api-v-0-user-get-users-by-company-get-plain';
import { ApiV0UserGetUsersByCompanyGet$Plain$Params } from '../fn/user/api-v-0-user-get-users-by-company-get-plain';
import { apiV0UserGetUserSignatureGet$Json } from '../fn/user/api-v-0-user-get-user-signature-get-json';
import { ApiV0UserGetUserSignatureGet$Json$Params } from '../fn/user/api-v-0-user-get-user-signature-get-json';
import { apiV0UserGetUserSignatureGet$Plain } from '../fn/user/api-v-0-user-get-user-signature-get-plain';
import { ApiV0UserGetUserSignatureGet$Plain$Params } from '../fn/user/api-v-0-user-get-user-signature-get-plain';
import { apiV0UserGetUserTypeGet$Json } from '../fn/user/api-v-0-user-get-user-type-get-json';
import { ApiV0UserGetUserTypeGet$Json$Params } from '../fn/user/api-v-0-user-get-user-type-get-json';
import { apiV0UserGetUserTypeGet$Plain } from '../fn/user/api-v-0-user-get-user-type-get-plain';
import { ApiV0UserGetUserTypeGet$Plain$Params } from '../fn/user/api-v-0-user-get-user-type-get-plain';
import { apiV0UserRegisterUserPost$Json } from '../fn/user/api-v-0-user-register-user-post-json';
import { ApiV0UserRegisterUserPost$Json$Params } from '../fn/user/api-v-0-user-register-user-post-json';
import { apiV0UserRegisterUserPost$Plain } from '../fn/user/api-v-0-user-register-user-post-plain';
import { ApiV0UserRegisterUserPost$Plain$Params } from '../fn/user/api-v-0-user-register-user-post-plain';
import { apiV0UserSaveUserSignaturePost } from '../fn/user/api-v-0-user-save-user-signature-post';
import { ApiV0UserSaveUserSignaturePost$Params } from '../fn/user/api-v-0-user-save-user-signature-post';
import { apiV0UserUpdateUserPost } from '../fn/user/api-v-0-user-update-user-post';
import { ApiV0UserUpdateUserPost$Params } from '../fn/user/api-v-0-user-update-user-post';
import { User } from '../models/user';
import { UserType } from '../models/user-type';

@Injectable({ providedIn: 'root' })
export class UserService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV0UserGetUserTypeGet()` */
  static readonly ApiV0UserGetUserTypeGetPath = '/api/v0/user/getUserType';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0UserGetUserTypeGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0UserGetUserTypeGet$Plain$Response(params?: ApiV0UserGetUserTypeGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UserType>> {
    const obs = apiV0UserGetUserTypeGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0UserGetUserTypeGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0UserGetUserTypeGet$Plain(params?: ApiV0UserGetUserTypeGet$Plain$Params, context?: HttpContext): Observable<UserType> {
    const resp = this.apiV0UserGetUserTypeGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserType>): UserType => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0UserGetUserTypeGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0UserGetUserTypeGet$Json$Response(params?: ApiV0UserGetUserTypeGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<UserType>> {
    const obs = apiV0UserGetUserTypeGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0UserGetUserTypeGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0UserGetUserTypeGet$Json(params?: ApiV0UserGetUserTypeGet$Json$Params, context?: HttpContext): Observable<UserType> {
    const resp = this.apiV0UserGetUserTypeGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserType>): UserType => r.body)
    );
  }

  /** Path part for operation `apiV0UserGetUsersByCompanyGet()` */
  static readonly ApiV0UserGetUsersByCompanyGetPath = '/api/v0/user/getUsersByCompany';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0UserGetUsersByCompanyGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0UserGetUsersByCompanyGet$Plain$Response(params?: ApiV0UserGetUsersByCompanyGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<User>>> {
    const obs = apiV0UserGetUsersByCompanyGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0UserGetUsersByCompanyGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0UserGetUsersByCompanyGet$Plain(params?: ApiV0UserGetUsersByCompanyGet$Plain$Params, context?: HttpContext): Observable<Array<User>> {
    const resp = this.apiV0UserGetUsersByCompanyGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<User>>): Array<User> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0UserGetUsersByCompanyGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0UserGetUsersByCompanyGet$Json$Response(params?: ApiV0UserGetUsersByCompanyGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<User>>> {
    const obs = apiV0UserGetUsersByCompanyGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0UserGetUsersByCompanyGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0UserGetUsersByCompanyGet$Json(params?: ApiV0UserGetUsersByCompanyGet$Json$Params, context?: HttpContext): Observable<Array<User>> {
    const resp = this.apiV0UserGetUsersByCompanyGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<User>>): Array<User> => r.body)
    );
  }

  /** Path part for operation `apiV0UserUpdateUserPost()` */
  static readonly ApiV0UserUpdateUserPostPath = '/api/v0/user/updateUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0UserUpdateUserPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0UserUpdateUserPost$Response(params?: ApiV0UserUpdateUserPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0UserUpdateUserPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0UserUpdateUserPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0UserUpdateUserPost(params?: ApiV0UserUpdateUserPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0UserUpdateUserPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV0UserRegisterUserPost()` */
  static readonly ApiV0UserRegisterUserPostPath = '/api/v0/user/registerUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0UserRegisterUserPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0UserRegisterUserPost$Plain$Response(params?: ApiV0UserRegisterUserPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = apiV0UserRegisterUserPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0UserRegisterUserPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0UserRegisterUserPost$Plain(params?: ApiV0UserRegisterUserPost$Plain$Params, context?: HttpContext): Observable<string> {
    const resp = this.apiV0UserRegisterUserPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0UserRegisterUserPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0UserRegisterUserPost$Json$Response(params?: ApiV0UserRegisterUserPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = apiV0UserRegisterUserPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0UserRegisterUserPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0UserRegisterUserPost$Json(params?: ApiV0UserRegisterUserPost$Json$Params, context?: HttpContext): Observable<string> {
    const resp = this.apiV0UserRegisterUserPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiV0UserDeactivateUserUsernamePut()` */
  static readonly ApiV0UserDeactivateUserUsernamePutPath = '/api/v0/user/deactivateUser/{username}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0UserDeactivateUserUsernamePut()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0UserDeactivateUserUsernamePut$Response(params: ApiV0UserDeactivateUserUsernamePut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0UserDeactivateUserUsernamePut(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0UserDeactivateUserUsernamePut$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0UserDeactivateUserUsernamePut(params: ApiV0UserDeactivateUserUsernamePut$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0UserDeactivateUserUsernamePut$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV0UserActivateUserUsernamePut()` */
  static readonly ApiV0UserActivateUserUsernamePutPath = '/api/v0/user/activateUser/{username}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0UserActivateUserUsernamePut()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0UserActivateUserUsernamePut$Response(params: ApiV0UserActivateUserUsernamePut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0UserActivateUserUsernamePut(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0UserActivateUserUsernamePut$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0UserActivateUserUsernamePut(params: ApiV0UserActivateUserUsernamePut$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0UserActivateUserUsernamePut$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV0UserDeleteUserUsernameDelete()` */
  static readonly ApiV0UserDeleteUserUsernameDeletePath = '/api/v0/user/deleteUser/{username}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0UserDeleteUserUsernameDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0UserDeleteUserUsernameDelete$Response(params: ApiV0UserDeleteUserUsernameDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0UserDeleteUserUsernameDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0UserDeleteUserUsernameDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0UserDeleteUserUsernameDelete(params: ApiV0UserDeleteUserUsernameDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0UserDeleteUserUsernameDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV0UserGetUserSignatureGet()` */
  static readonly ApiV0UserGetUserSignatureGetPath = '/api/v0/user/getUserSignature';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0UserGetUserSignatureGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0UserGetUserSignatureGet$Plain$Response(params?: ApiV0UserGetUserSignatureGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = apiV0UserGetUserSignatureGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0UserGetUserSignatureGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0UserGetUserSignatureGet$Plain(params?: ApiV0UserGetUserSignatureGet$Plain$Params, context?: HttpContext): Observable<string> {
    const resp = this.apiV0UserGetUserSignatureGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0UserGetUserSignatureGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0UserGetUserSignatureGet$Json$Response(params?: ApiV0UserGetUserSignatureGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = apiV0UserGetUserSignatureGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0UserGetUserSignatureGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0UserGetUserSignatureGet$Json(params?: ApiV0UserGetUserSignatureGet$Json$Params, context?: HttpContext): Observable<string> {
    const resp = this.apiV0UserGetUserSignatureGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiV0UserSaveUserSignaturePost()` */
  static readonly ApiV0UserSaveUserSignaturePostPath = '/api/v0/user/saveUserSignature';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0UserSaveUserSignaturePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0UserSaveUserSignaturePost$Response(params?: ApiV0UserSaveUserSignaturePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0UserSaveUserSignaturePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0UserSaveUserSignaturePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0UserSaveUserSignaturePost(params?: ApiV0UserSaveUserSignaturePost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0UserSaveUserSignaturePost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
